import { useIntl } from "react-intl";
import MonthCalendar from "./components/monthCalendar";
import NextSchedulings from "./components/nextSchedulings";
import Schedule from "./components/schedule";
import BigNumbers from "./components/bigNumbers";
import UnviwedSchedulingsDialog from "./components/schedule/dialogs/UnviwedSchedulingsDialog";

import { getFirstDayOfWeek, getLastDayOfWeek } from "../../../../utils/dateUtils";
import { Loading } from "../../../../utils/loading";
import useMediaQuery from '@mui/material/useMediaQuery';

import { useDealershipConsultantSchedule } from "../../../../hooks/useDealershipConsultantSchedule";

const MaintenanceControl = (props: any) => {
  const intl = useIntl();
  const {
    loading,
    currentDate,
    scheduleSidebar,
    consultantMonthSchedule,
    scheduleViewType,
    unviewedScheduleModal,
    unviwedSchedulings,
    setCurrentDate,
    setScheduleSidebar,
    setScheduleViewType,
    closeUnviewdSchedulingsDialog
  } = useDealershipConsultantSchedule();

  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <>
      {loading ? (
        <Loading label={intl.formatMessage({ id: "intl-msg:dealership.maintenanceControl.loading" })} />
      ) : (
        <>
          <BigNumbers
            consultantMonthSchedule={consultantMonthSchedule}
            firstWeekDay={getFirstDayOfWeek(currentDate)}
            currentDate={currentDate}
            scheduleViewType={scheduleViewType}
          />

          <div className="text-size-18 text-bold padding-y-10">
            {intl.formatMessage({ id: "intl-msg:dealership.maintenanceControl.heading" })}
          </div>
          <div className="panel panel-default panel-body shadow-default padding-0">
            <div className={`${isMobile ? 'display-flex flex-direction-column' : 'display-flex gap-10'}`}>
              {isMobile && scheduleSidebar && (
                  <div className="mobile-calendar-container">
                    <div className="mobile-calendar-centered">
                      <MonthCalendar
                        dayChoosed={currentDate}
                        chooseDay={(date) => setCurrentDate(date)}
                      />
                    </div>
                    <div>
                      <NextSchedulings
                        now={currentDate}
                        consultantMonthSchedule={consultantMonthSchedule}
                      />
                    </div>
                  </div>
              )}

              {scheduleSidebar && !isMobile && (
                <div className="flex-basis-250">
                  <MonthCalendar
                    dayChoosed={currentDate}
                    chooseDay={(date) => setCurrentDate(date)}
                  />
                  <NextSchedulings
                    now={currentDate}
                    consultantMonthSchedule={consultantMonthSchedule}
                  />
                </div>
              )}

              <div 
                style={{ 
                  borderLeftWidth: !isMobile && scheduleSidebar ? 1 : 0,
                  borderTopWidth: isMobile && scheduleSidebar ? 1 : 0,
                  flex: 1,
                  minWidth: 0
                }} 
              >
                <Schedule
                  firstWeekDay={getFirstDayOfWeek(currentDate)}
                  lastWeekDay={getLastDayOfWeek(currentDate)}
                  consultantMonthSchedule={consultantMonthSchedule}
                  currentDate={currentDate}
                  setCurrentDate={setCurrentDate}
                  handleScheduleSidebar={() => setScheduleSidebar(!scheduleSidebar)}
                  scheduleViewType={scheduleViewType}
                  setScheduleViewType={setScheduleViewType}
                />
              </div>
            </div>
          </div>

          <UnviwedSchedulingsDialog
            show={!!unviewedScheduleModal}
            onClose={closeUnviewdSchedulingsDialog}
            unviwedSchedulings={unviwedSchedulings}
          />
        </>
      )}
    </>
  );
};

export default MaintenanceControl;
